import classnames from 'classnames';
import IconNext from './icon_next.svg?react';
import IconPrev from './icon_prev.svg?react';
import s from '../index.module.scss';

export const SliderNavigation = ({ onNext, onPrev }) => (
  <div className={s.buttons}>
    <button
      type="button"
      className={classnames(s.btn_nav, 'slider_nav')}
      onClick={() => onPrev()}
    >
      <IconPrev />
    </button>
    <button
      type="button"
      className={classnames(s.btn_nav, 'slider_nav')}
      onClick={() => onNext()}
    >
      <IconNext />
    </button>
  </div>
);
